module.exports = {
    // basic
    'help-document': 'documento de ayuda',

    // raw
    'video-tag-not-supported': 'Su navegador no soporta la etiqueta de vídeo.',
    'help-list-help': `
        Si tiene más preguntas, comuníquese con nosotros en <a class="alert-link" href="mailto:ops@welldrive.com">ops@welldrive.com</a>, <a class="alert-link" href="tel: 8777048270">(877) 704-8270</a> o <a class="alert-link" href="tel:8557048270">(855) 704-8270 (alternativo)</a>.
    `,

    // template
};
